import request from 'admin-ng/util/request-promise';
import {ASSET_TYPES, ITEM_TYPES} from '.';

export const getItemTypes = params => request(ITEM_TYPES, 'get', params);
export const getAssetTypes = (itemTypeId, params) =>
  request(ASSET_TYPES, 'get', params);
